import * as selfAdhesionApi from '@/network/api/self.api.js'

/** consults adhesion process info
@return { promise } - returns adhesion process info response
*/
export const consultAdhesionProcess = async (context, payload) => {
    const res = await selfAdhesionApi.consultAdhesionProcess(payload)
    return res
}

/** validates phone number
@return { promise } - validates phone number
*/
export const finishAdhesionProcess = async (context, payload) => {
    const res = await selfAdhesionApi.finishAdhesionProcess(payload)
    return res
}

/** Resend OTP to phoneNumber
@return { promise }
*/
export const resendFinishAdhesionProcessToken = async (context, payload) => {
    const res = await selfAdhesionApi.resendFinishAdhesionProcessToken(payload)
    return res
}

/** consults recover credentials process info
@return { promise } - returns recover credentials process info response
*/
export const consultRecoverCredentialsProcess = async (context, payload) => {
    const res = await selfAdhesionApi.consultRecoverCredentialsProcess(payload)
    return res
}
